<template>
  <div >
    <div
      class="list"
      v-for="(item,index) in authorityMenu"
      :class="{ 'active': index === selected }"
      @click="to_page(index,item.name)" >
      <h3><Icon :type="item.icon"/>{{ item.title }}<Icon type="md-arrow-dropright" /></h3></div>
     <!--二级菜单-->
      <!--<div class="list"><h3><Icon type="md-list"/>报表管理<Icon type="ios-arrow-down"/></h3>-->
        <!--<ul>-->
          <!--<li>财务报表</li>-->
          <!--<li>人事报表</li>-->
        <!--</ul>-->
      <!--</div>-->
  </div>
</template>
<script>
  import Routers from '@/router/routers.js'
  export default {
    name: 'sidebar',
    data () {
      return{
        selected:0,
        menuList:[
          {
            name:'home',
            ID:1,
            title:'我的工作台',
            icon:'md-home'
          },
          {
            name:'reportMain_page',
            ID:2,
            title:'报表管理',
            icon:'md-list'
          },
          {
            name:'shopMain_page',
            ID:3,
            title:'资产信息',
            icon:'md-cash'
          },
          {
            name:'customerData_page',
            ID:4,
            title:'租户资料',
            icon:'md-contact'
          },
          {
            name:'leaseContract_page',
            ID:5,
            title:'租赁合同',
            icon:'ios-paper'
          },
          {
            name:'costMain_page',
            ID:6,
            title:'缴费管理',
            icon:'logo-usd'
          },
          {
            name:'noticeMain_page',
            ID:7,
            title:'通知预警',
            icon:'ios-warning'
          },
          {
            name:'sysMain_page',
            ID:8,
            title:'系统信息',
            icon:'ios-settings'
          },

        ],
        authorityMenu:[]
      }
    },
    methods: {
      to_page(index,name){
        this.selected = index;
        this.$router.push({
          name:name
        })
      },
      get_menuList(){
        let jsonMenu = sessionStorage.getItem('menu');
        let menuHere = JSON.parse(jsonMenu);
        if(jsonMenu){
          let menuList = this.menuList;
          for(let i=0;i<menuHere.length;i++){
            for(let y=0;y<menuList.length;y++){
              if(menuHere[i].ID == menuList[y].ID){
                this.authorityMenu.push(menuList[y]);
              }
            }
          }
        }else {
          this.$Message.error('没有菜单');
          this.$router.push({
            name: 'error_404'
          })
        }
      }
    },
    created(){

    },
    mounted () {
      let menulist = this.menuList;
      for(let i in menulist){
        if(menulist[i].name === this.$route.name){
          this.selected = Number(i);
        }
      }
      this.get_menuList();
    }
  }
</script>
<style lang="less" scoped>
  .list{
    line-height:40px;
    color: #fff;
    cursor: pointer;
    box-sizing: content-box;
    &.active{ color: #ececec;background-color: rgba(230, 230, 230, 0.1); }
    h3{ font-size:14px; font-weight: normal;padding: 0 10px;position: relative;
      i:nth-child(1){margin-right:10px;}
      i:nth-child(2){
        position: absolute;
        right:20px;
        font-size: 18px;
        top: 50%;
        margin-top: -10px;
      }
    }
    ul{
      li{
        box-sizing: content-box;
        font-size: 13px;
        padding: 0 10px;
        padding-left: 35px;
      }
    }
  }
  @media (min-width: 1680px) {
    .list{
      line-height: 60px;
      h3{
        font-size:16px;
        i:nth-child(2){ font-size: 20px; }
      }
    }
  }
  @media (min-width: 1920px) {
    .list{
      line-height: 80px;
      h3{
        font-size:18px;
        i:nth-child(2){ font-size: 22px; }
      }
    }
  }

</style>
